// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__17hQB","info":"Note_info__dQI6i","note":"Note_note__3Rt3Z","actions":"Note_actions__2_y5t"};